import { TranslationMessages } from 'react-admin';
import englishMessages from 'ra-language-english';

const customEnglishMessages: TranslationMessages = {
    ...englishMessages,
    pos: {
        search: 'Search',
        configuration: 'Configuration',
        language: 'Language',
        theme: {
            name: 'Theme',
            light: 'Light',
            dark: 'Dark',
        },
        dashboard: {
            monthly_revenue: 'Monthly Revenue',
            month_history: '30 Day Revenue History',
            new_orders: 'New Orders',
            pending_reviews: 'Pending Reviews',
            all_reviews: 'See all reviews',
            new_customers: 'New Customers',
            all_customers: 'See all customers',
            pending_orders: 'Pending Orders',
            order: {
                items:
                    'by %{customer_name}, one item |||| by %{customer_name}, %{nb_items} items',
            },
            welcome: {
                title: 'Welcome to the react-admin e-commerce demo',
                subtitle:
                    "This is the admin of an imaginary poster shop. Feel free to explore and modify the data - it's local to your computer, and will reset each time you reload.",
                ra_button: 'react-admin site',
                demo_button: 'Source for this demo',
            },
        },
        menu: {
            sales: 'Sales',
            customers: 'Customers',
            products: 'Products',
            users: 'Users',
            shipping: 'Shipping',
            orders: 'Orders',
            profile: 'Profile',
            blogs: 'News',
            sellers: 'Sellers',
            directory: 'Directory',
            settings: 'Settings',
            dashboard: 'Dashboard',
            importExport: 'Import/Export',
        },
    },
    resources: {
        customers: {
            name: 'Customer |||| Customers',
            page: {
                delete: 'Delete Customer',
            },
            errors: {
                password_mismatch:
                    'The password confirmation is not the same as the password.',
            },
        },
        products: {
            name: 'Product |||| Products',
            notification: { 
                updated: 'The %{name} was updated successfully',
                created: 'The %{name} was created successfully',
                deleted: 'The %{name} was deleted successfully',
            },            
        },
        productrecycle: {
            name: 'Reprocessed |||| Reprocessed',
            notification: {
                updated: 'The %{name} was updated successfully',
                created: 'The %{name} was created successfully',
                deleted: 'The %{name} was deleted successfully',
            },
        },
        cityshipping: {
            name: 'Shipping |||| Shipping',
            notification: { 
                updated: 'The %{name} was updated successfully',
                created: 'The %{name} was created successfully',
                deleted: 'The %{name} was deleted successfully',
            },            
        },       
        orders: {
            name: 'Order |||| Orders',
            notification: {
                updated: 'The %{name} was updated successfully',
                created: 'The %{name} was created successfully',
                deleted: 'The %{name} was deleted successfully',
            },            
        },
        productpricing: {
            name: 'Price |||| Pricing',
            notification: {
                updated: 'The %{name} was updated successfully',
                created: 'The %{name} was created successfully',
                deleted: 'The %{name} was deleted successfully',
            },            
        },
        sellerfilter: {
            name: 'Pricing |||| Pricing',
            notification: {
                updated: 'The %{name} was updated successfully',
                created: 'The %{name} was created successfully',
                deleted: 'The %{name} was deleted successfully',
            },            
        },
        orderhistory: {
            name: 'Comment |||| Comment',
            notification: {
                updated: 'The %{name} was updated successfully',
                created: 'The %{name} was created successfully',
                deleted: 'The %{name} was deleted successfully',
            },            
        },
        blogs: {
            name: 'News article |||| News',
            fields: {
                products: 'Products',
                created_at: 'Created',
                published_at: 'Published',
            },
            notification: {
                updated: 'The %{name} was updated successfully',
                created: 'The %{name} was created successfully',
                deleted: 'The %{name} was deleted successfully',
            },
        },
        categories: {
            name: 'Category |||| Categories',
            fields: {
                products: 'Products',
            },
            notification: {
                updated: 'The %{name} was updated successfully',
                created: 'The %{name} was created successfully',
                deleted: 'The %{name} was deleted successfully',
            },
        },
        subcategories: {
            name: 'Subcategory |||| SubCategories',
            fields: {
                products: 'Products',
            },
            notification: {
                updated: 'The %{name} was updated successfully',
                created: 'The %{name} was created successfully',
                deleted: 'The %{name} was deleted successfully',
            },
        },
        productsegments: {
            name: 'Segments |||| Segments',
            fields: {
                products: 'Segments',
            },
            notification: {
                updated: 'The %{name} was updated successfully',
                created: 'The %{name} was created successfully',
                deleted: 'The %{name} was deleted successfully',
            },            
        },
        segments: {
            name: 'Segments |||| Segments',
            fields: {
                products: 'Segments',
            },
            notification: {
                updated: 'The %{name} was updated successfully',
                created: 'The %{name} was created successfully',
                deleted: 'The %{name} was deleted successfully',
            },            
        },
        customersegments: {
            name: 'Segments |||| Segments',
            fields: {
                products: 'Products',
            },
        },
        sellers: {
            name: 'Sellers |||| Sellers',
            fields: {
                products: 'Products',
            },
        },
        settings: {
            name: 'Settings |||| Settings',
            fields: {
                products: 'Products',
            },
        }, 
        users: {
            name: 'User |||| Users',
            fields: {
                products: 'Products',
            },
            notification: {
                updated: 'The %{name} was updated successfully',
                created: 'The %{name} was created successfully',
                deleted: 'The %{name} was deleted successfully',
            },            
        }, 
        profile: {
            name: 'Profile |||| Profile',
            fields: {
                products: 'Products',
            },
            notification: {
                updated: 'The %{name} was updated successfully',
                created: 'The %{name} was created successfully',
                deleted: 'The %{name} was deleted successfully',
            },            
        }, 
        states: {
            name: 'Location |||| Locations',
            fields: {
                products: 'States',
            },
            notification: {
                updated: 'The %{name} was updated successfully',
                created: 'The %{name} was created successfully',
                deleted: 'The %{name} was deleted successfully',
            },            
        },       
        statecities: {
            name: 'City |||| Cities',
            fields: {
                products: 'Cities',
            },
            notification: {
                updated: 'The %{name} was updated successfully',
                created: 'The %{name} was created successfully',
                deleted: 'The %{name} was deleted successfully',
            },            
        },      
        sellerRegistrationRequests: {
            name: 'Seller Registration Request |||| Seller Registration Requests',
        },
        unregistered: {
            name: 'Unregistered |||| Unregistered',
            fields: {
                products: 'Cities',
            },
            notification: {
                updated: 'The %{name} was updated successfully',
                created: 'The %{name} was created successfully',
                deleted: 'The %{name} was deleted successfully',
            },            
        },
        customercontacts: {
            name: 'Contact Enquiry |||| Contact Enquiries',
        },
        offers: {
            name: 'Offers |||| Offers',
            fields: {
                offers: 'Offers',
            },
            notification: {
                updated: 'The %{name} was updated successfully',
                created: 'The %{name} was created successfully',
                deleted: 'The %{name} was deleted successfully',
            },
        },
        bids: {
            name: 'Bids |||| Bids',
            fields: {
                offers: 'Bids',
            },
            notification: {
                updated: 'The %{name} was updated successfully',
                created: 'The %{name} was created successfully',
                deleted: 'The %{name} was deleted successfully',
            },
        },
        inquiries: {
            name: 'Inquiries |||| Inquiries',
            fields: {
                offers: 'Inquiries',
            },
            notification: {
                updated: 'The %{name} was updated successfully',
                created: 'The %{name} was created successfully',
                deleted: 'The %{name} was deleted successfully',
            },
        },
        directorycategories: {
            name: 'Category |||| Categories',
            fields: {
                category_name: 'Category Name',
                category_description: 'Description',
            },
            notification: {
                updated: 'The %{name} was updated successfully',
                created: 'The %{name} was created successfully',
                deleted: 'The %{name} was deleted successfully',
            },
        },
        directorysubcategories: {
            name: 'Subcategory |||| Subcategories',
            fields: {
                category_id: 'Category',
                subcategory_name: 'Subcategory Name',
                subcategory_description: 'Description',
            },
            notification: {
                updated: 'The %{name} was updated successfully',
                created: 'The %{name} was created successfully',
                deleted: 'The %{name} was deleted successfully',
            },
        },
        directorycontacts: {
            name: 'Contact |||| Contacts',
            fields: {
                company_name: 'Company Name',
                gst_number: 'GST Number',
                first_name: 'First Name',
                last_name: 'Last Name',
                email_address: 'Email Address',
                address_line1: 'Address Line 1',
                address_line2: 'Address Line 2',
                address_city: 'City',
                address_state: 'State',
                address_pin: 'PIN',
                phone_landline: 'Landline Phone',
                phone_mobile: 'Mobile Phone',
                display_priority: 'Display Priority',
                categories: 'Categories',
            },
            notification: {
                updated: 'The %{name} was updated successfully',
                created: 'The %{name} was created successfully',
                deleted: 'The %{name} was deleted successfully',
            },
        },
    },
};

export default customEnglishMessages;
